export const CCM19_API_KEY = "c9de052f9cfad9ef630d69c806e3cd3b9ba5b01081023ea7"
export const CCM19_DOMAIN = "66f272248da040e9ee0c2cf2"
export const CCM19_THEME = "66f272258da040e9ee0c2d73"
